/* eslint no-restricted-imports: 0 */
import { IsoDate } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/types"
import { Nullable } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import React from "react"
import { RangeCalendarState } from "react-stately"

// Re-export react-stately types for use within DateRangePicker components
export type { RangeCalendarState }

export type DateRangePickerValue = {
    start: Nullable<IsoDate> // e.g. "2022-01-01"
    end: Nullable<IsoDate>
}

export type DateRangeFormattedValue = {
    start: Nullable<string> // e.g. "01/01/2022"
    end: Nullable<string>
}

export type DateRangePickerError = {
    start?: string
    end?: string
}

export enum PredefinedDateType {
    Normal = "normal",
    Prominent = "prominent",
}

export type PredefinedDateGroup = {
    groupId: PredefinedDateGroupId
    groupLabel: string
    dates: PredefinedDateValue[]
}

export enum PredefinedDateGroupId {
    Main = "main",
    Weekly = "weekly",
    Monthly = "monthly",
    Rolling = "rolling",
}

export type PredefinedDateValue = {
    value: DateRangePickerValue
    label: string
    icon?: React.ReactNode
}

export type OnChangeOptions = {
    changeMode?: "temporary" | "immediate"
    resetErrors?: boolean
}
